import {
    AccordionContainerDPC,
    AccordionDPC,
    AllegatoContainerDPC,
    AllegatoDPC,
    LinksContainerDPC,
    LinksDPC,
    PageContainerDPC,
    PrintButtonDPC
} from '@dpc-fe/shared';
import {graphql} from 'gatsby';
import React from 'react';
import {getAccordionAndTabLinks, getSlug, prop} from "../functions/functions";
import moment from "moment";
import "moment/locale/it";
import CoverAudiobook from '@dpc-fe/shared/img/banner_audiobook.jpeg'


export default ({data, pageContext}) => {

    const language = '/' + pageContext.lang;
    const correlazioniTypes = ['podcast','audiobook','comunicato_stampa', 'notizia', 'approfondimento', 'pubblicazione', 'corso', 'pagina', 'sezione'];
    const correlazioni = data.node?.relationships?.field_correlazioni?.filter(item => item.field_categoria_primaria == null || correlazioniTypes.indexOf(item.field_categoria_primaria) > -1).map(item => {
        return {
            title: 'Sfoglia il fumetto',
            slug: getSlug(language + item.fields.slug, process.env.MINISITO_INR_ATTIMO_DECISIVO, item.relationships.field_sottodominio.name),
            svg: "sfogliabile"
        }
    });
    const allegati = data.node?.relationships?.field_correlazioni?.filter(item => item.field_categoria_primaria == 'pubblicazione').flatMap(item => {
		return item.relationships?.field_allegati?.map(allegato => {
			return{
				titleLinkEsterno: "Scarica la versione PDF",
				title: "Scarica la versione <b>PDF</b>",
				slug: allegato?.relationships?.field_allegato?.localFile?.publicURL,
				svg: "pdf"
			}
		})
    });
    const altreVersioni = correlazioni && allegati? correlazioni.concat(allegati) : correlazioni ? correlazioni : allegati ? allegati : []; 

    moment.locale('it');
    const breadcrumbItem = {
        name: data.node.field_titolo_esteso,
        slug: data.node.fields && data.node.fields.slug ? data.node.fields.slug : null,
        active: true
    }

	function formatDate(inputDate) {
		const months = [
			"gen", "feb", "mar", "apr", "mag", "giu",
			"lug", "ago", "set", "ott", "nov", "dic"
		];
		const date = new Date(inputDate);
		const day = date.getDate();
		const month = months[date.getMonth()];
		const year = date.getFullYear();

		return `${day} ${month} ${year}`;
	}

    return (
        <PageContainerDPC basePathNavbar={process.env.MINISITO_INR_ATTIMO_DECISIVO_URL}
            //checkTorna={true}
            //linkTorna={`/${pageContext.lang}${data.elenco?.fields.slug}`}
            //textTorna={data.elenco?.title}
                          menuItems={pageContext.menu}
                          pageId={data.node.drupal_internal__nid}
						  slugTraduzione={data.node.relationships.field_riferimento_traduzione ? data.node.relationships.field_riferimento_traduzione.fields.slug : ''}
                          title={data.node.title}
                          env={process.env.ENV}
                          lang={pageContext.lang}
                          breadcrumbItem={breadcrumbItem}
                          immagineShare={data.node.relationships?.field_immagine_dettaglio ? process.env.MINISITO_INR_ATTIMO_DECISIVO_URL + data.node.relationships?.field_immagine_dettaglio?.relationships?.image?.localFile?.publicURL : process.env.MINISITO_INR_ATTIMO_DECISIVO_URL + pageContext.socialImg?.relationships?.image?.localFile?.publicURL}
                          abstractShare={data.node.body?.processed ? data.node.body.processed.replace(/<\/?[^>]+(>|$)/g, "") : ''}
                          slug={process.env.MINISITO_INR_ATTIMO_DECISIVO_URL + '/' + pageContext.lang + data.node.fields?.slug}
                          minisiti={prop}
                          menuFooterItems={pageContext.menuFooter}
                          isInrAttimoDecisivo={true}
        >
            <div className="container">
                <div className={"px-custom"}>
                    <div className={"row"}>
                        <div className="col-12">
							<section>

								<h1>{data.node.field_titolo_esteso}</h1>
								<div className="redazionale"
									 dangerouslySetInnerHTML={{__html: data.node.body ? data.node.body.processed : ''}}
								/>
								<img className="banner-player" src={CoverAudiobook} alt="L'attimo decisivo Audiobook"></img>

								{data.node.relationships.field_podcast && data.node.relationships.field_podcast.length > 0 ?
									<>
										{data.node.relationships.field_podcast.map(podcast => (
											<>
												{podcast.field_spotify_check ?
													<div className="mt-4 has-spotify"
														 dangerouslySetInnerHTML={{ __html: podcast.field_spotify_embed }}
													/>
													:
													<div className="audio-player has-mp3"
														 data-trackname={podcast.field_titolo_esteso}
														 data-artist={
															 (podcast.field_titolo_contenuto_originale ? podcast.field_titolo_contenuto_originale : '') +
															 " • " +
															 "Protezione Civile • " +
															 (podcast.field_data ? formatDate(podcast.field_data) : '')
														 }
														 data-source={process.env.MINISITO_INR_ATTIMO_DECISIVO_URL + podcast.relationships?.field_file_audio?.localFile?.publicURL}
														 data-cover={podcast.relationships?.field_immagine_anteprima?.relationships?.image?.localFile?.publicURL}
													></div>
												}

												<AccordionContainerDPC id={podcast.drupal_internal__nid}>
													<AccordionDPC
														title={podcast.field_titolo_esteso ? podcast.field_titolo_esteso : ''}
														body={podcast.body ? podcast.body.processed : ''}
														id={podcast.drupal_internal__nid}
														accordionId={podcast.drupal_internal__nid}
													/>
												</AccordionContainerDPC>
											</>
										))}
									</>
									: null
								}

								<section className="attachments-and-links">
									{(altreVersioni && altreVersioni.length > 0) &&
										<LinksContainerDPC titoloSezione={'Altre versioni'}>
											<LinksDPC links={altreVersioni}/>
										</LinksContainerDPC>}
								</section>
							</section>
						</div>
					</div>
				</div>
			</div>
		</PageContainerDPC>
    );
};


export const query = graphql`
query($slug: String!) {
  node:nodeAudiobook (fields: { slug: { eq: $slug } }) {
    drupal_internal__nid
    id
    title
    field_data
    field_titolo_esteso
    field_id_contenuto_originale
    body {
      processed
    }
    fields {
      slug
    }
    relationships {
      field_sottodominio {
        name
      }
   	  field_riferimento_traduzione {
        fields {
          slug
        }
      }
      field_podcast{
        drupal_internal__nid
        field_titolo_esteso
        field_titolo_contenuto_originale
        field_data
        field_spotify_check
        field_spotify_embed
        body{
          processed
          value
        }
        field_abstract {
          processed
          value
        }
        fields {
            slug
        }
        relationships {
          field_file_audio {
            localFile {
              publicURL
              absolutePath
            }
          }
          field_accordion {
            field_titolo
            field_tabella {
              processed
            }
            field_testo {
              processed
              value
            }
            relationships {
              field_immagine {
                field_alt
                field_didascalia
                relationships {
                  image:field_immagine{
                  localFile {
                    publicURL
                    childImageSharp {
                        fluid(maxWidth: 1100) {
                          ...GatsbyImageSharpFluid_noBase64
                        }
                      }
                    }
                  }
                }
              }
              field_video {
                ...videoFragment
                ...webinarFragment
              }
              field_link_interni{
                ...pubblicazioneFragment
                  ...notiziaFragment
                  ...approfondimentoFragment
                  ...normativaFragment
                  ...pageFragment
                  ...bandoDiGaraFragment
                  ...comunicatoStampaFragment
                  ...corsoFragment
                  ...mappaFragment
                  ...timelineFragment
                  ...sezioneConAnticipazioniFragment
                  ...sezioneSenzaAnticipazioniFragment
                  ...elencoApprofondimentiFragment
                  ...elencoGlossariFragment
                  ...elencoAttualitaFragment
                  ...elencoPodcastFragment
                  ...elencoPubblicazioniFragment
                  ...elencoNormativaFragment
                  ...elencoBandiEContrattiFragment
                  ...elencoFotoVideoFragment
                  ...homepageVolontariatoFragment
                  ...homepageRelazioniFragment
                  ...homepageRischiFragment
                  ...homepageNazionaleFragment
                  ...homepageMappeFragment
                  ...homepageGiovaniFragment
                  ...homepageFormazioneFragment
                  ...homepageEventiFragment
                  ...homepageEmergenzeFragment
                  ...homepageDocsFragment
                  ...homepageDomandeFragment
                  ...homepagePnrrFragment
                  ...homepageItAlertFragment
                  ...homepageIononrischioFragment
                  ...homepageInrAttimoDecisivoFragment
                  ...podcastFragment
				  ...audiobookFragment
                  ...bollettinoCriticitaFragment
                  ...bollettinoVigilanzaFragment
                  ...sezioneAllertaMeteoIdroFragment
                  ...galleriaFotoFragment
                  ...videoFragment
				  ...webinarFragment
                  ...galleriaFlickrFragment
              }
            }
            drupal_internal__id
          }
          field_sottodominio {
            name
          }
          field_immagine_anteprima {
            field_alt
            field_didascalia
            relationships{
              image:field_immagine{
                  localFile {
              publicURL
                    childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
            }
          }
          field_immagine_dettaglio {
            field_alt
            field_didascalia
            relationships{
              image:field_immagine{
                  localFile {
              publicURL
                    childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
            }
          }
        }
      }
      field_correlazioni {
        ...pubblicazioneFragment
              ...notiziaFragment
              ...approfondimentoFragment
              ...normativaFragment
              ...pageFragment
              ...bandoDiGaraFragment
              ...comunicatoStampaFragment
              ...corsoFragment
              ...mappaFragment
              ...timelineFragment
              ...sezioneConAnticipazioniFragment
              ...sezioneSenzaAnticipazioniFragment
              ...elencoApprofondimentiFragment
              ...elencoGlossariFragment
              ...elencoAttualitaFragment
              ...elencoPodcastFragment
              ...elencoPubblicazioniFragment
              ...elencoNormativaFragment
              ...elencoBandiEContrattiFragment
              ...elencoFotoVideoFragment
              ...homepageVolontariatoFragment
              ...homepageRelazioniFragment
              ...homepageRischiFragment
              ...homepageNazionaleFragment
              ...homepageMappeFragment
              ...homepageGiovaniFragment
              ...homepageFormazioneFragment
              ...homepageEventiFragment
              ...homepageEmergenzeFragment
              ...homepageDocsFragment
              ...homepageDomandeFragment
			...homepagePnrrFragment
			...homepageItAlertFragment
			...homepageIononrischioFragment
			...homepageInrAttimoDecisivoFragment
			...podcastFragment
			...audiobookFragment
              ...bollettinoCriticitaFragment
              ...bollettinoVigilanzaFragment
              ...sezioneAllertaMeteoIdroFragment
              ...galleriaFotoFragment
              ...videoFragment
			...webinarFragment
              ...galleriaFlickrFragment
      }
      field_allegati {
        title
        field_titolo_esteso
        relationships {
          field_allegato {
            filesize
            localFile {
              publicURL
              extension
            }
            filename
          }
        }
      }
      field_ambito {
        name
      }
      field_immagine_anteprima {
        field_alt
        field_didascalia
        relationships {
          image:field_immagine{
        localFile {
          publicURL
          childImageSharp {
                  fluid(maxWidth: 1100) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
          }
        }
      }
    }
  }
}
`;
